import Box from '@/common/components/Box';
import Skeleton from '@/common/components/Skeleton';

const FinancialSectionLoadingState = () => {
  return (
    <Box className='p-4 flex flex-col gap-4'>
      <div className="flex items-center gap-x-3">
        <Skeleton width={75} height={34} className='bg-white-100' />

        <Skeleton width={120} height={28} />
      </div>

      <div className='flex flex-col gap-4'>
        <div className='flex items-center gap-3'>
          <Skeleton width={250} />

          <div className='flex items-center gap-1 text-white-400'>
            <Skeleton width={24} height={20} className='bg-white-100' />

            <Skeleton width={60} />
          </div>
        </div>

        <div className='flex items-center gap-3 flex-wrap'>
          <Skeleton width={120} />

          {new Array(3).fill(null).map((_, i) => (
            <div key={`product_category_${i}`} className='flex items-center gap-1 text-white-400'>
              <Skeleton width={24} height={24} className='bg-white-100' />

              <Skeleton width={64} />
            </div>
          ))}
        </div>

        <div className='flex items-center gap-3 flex-wrap'>
          <Skeleton width={110} />

          <Box className='p-4 flex items-center gap-4'>
            <div className='flex items-center gap-1'>
              <Skeleton width={24} height={24} circle className='bg-white-100' />

              <div className='space-y-1'>
                <Skeleton width={50} height={12} />
                <Skeleton width={100} />
              </div>
            </div>

            <div className='flex items-center gap-1'>
              <Skeleton width={24} height={20} className='bg-white-100' />

              <div className='space-y-1'>
                <Skeleton width={50} height={12} />
                <Skeleton width={50} />
              </div>
            </div>

            <div className='flex items-center gap-1'>
              <Skeleton width={24} height={20} className='bg-white-100' />

              <div className='space-y-1'>
                <Skeleton width={50} height={12} />
                <Skeleton width={100} />
              </div>
            </div>

            <div className='flex items-center gap-1'>
              <Skeleton width={24} height={24} circle className='bg-white-100' />

              <div className='space-y-1'>
                <Skeleton width={80} height={12} />
                <Skeleton width={120} />
              </div>
            </div>
          </Box>
        </div>

        <div className='flex items-center gap-3'>
          <Skeleton width={220} />

          <div className='flex items-center gap-1 text-white-400'>
            <Skeleton width={24} height={20} className='bg-white-100' />

            <Skeleton width={80} />
          </div>
        </div>
      </div>
    </Box>
  )
}

export default FinancialSectionLoadingState;
